import { useEffect, useState } from "react";
import { BookOpen, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function QuranCard() {
  const [ayah, setAyah] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/quran/daily-ayah").then((r) => setAyah(r.data)).catch(() => setErr(true));
  }, []);

  return (
    <section className="py-24 md:py-32 px-6 md:px-10 relative overflow-hidden" data-testid="quran-card">
      <div className="absolute inset-0 pattern-girih opacity-10" />
      <div className="relative max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 items-stretch">
          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Qur'an</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-3 text-ink leading-tight">
              Today's <em className="text-navy">verse</em>.
            </h2>
            <p className="mt-5 text-ink/65 font-light leading-relaxed">
              A daily reminder from the Book of Allah. Read, reflect, and explore the full Qur'an translation and
              recitation at <span className="text-navy font-medium">quran.com</span>.
            </p>
            <a
              href="https://quran.com"
              target="_blank"
              rel="noreferrer"
              data-testid="quran-open-full-btn"
              className="inline-flex items-center gap-2 mt-8 rounded-full bg-navy text-cream px-6 py-3 text-sm font-semibold uppercase tracking-wider hover:bg-navy-900 transition-all hover:-translate-y-0.5"
            >
              <BookOpen size={14} /> Open Full Qur'an <ArrowRight size={14} />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="relative rounded-3xl bg-navy text-cream p-8 md:p-12 overflow-hidden min-h-[320px] flex flex-col justify-between">
              <div className="absolute inset-0 pattern-girih opacity-25" />
              <div className="relative">
                {ayah ? (
                  <>
                    <div className="flex items-center justify-between">
                      <div className="text-[10px] uppercase tracking-[0.25em] text-gold font-semibold">
                        Surah {ayah.surah_name} · Ayah {ayah.number_in_surah}
                      </div>
                      <div className="font-arabic text-xl text-gold" dir="rtl">{ayah.surah_name_arabic}</div>
                    </div>
                    <div className="mt-8 font-arabic text-3xl md:text-4xl lg:text-[2.6rem] text-cream text-right" dir="rtl" style={{ lineHeight: "2.4" }}>
                      {ayah.text_arabic}
                    </div>
                    <div className="mt-8 text-base md:text-lg text-cream/85 font-light leading-relaxed italic">
                      "{ayah.text_english}"
                    </div>
                    <a
                      href={ayah.quran_com_url}
                      target="_blank"
                      rel="noreferrer"
                      className="relative inline-flex items-center gap-1.5 mt-6 text-gold text-sm hover:gap-2.5 transition-all"
                      data-testid="quran-ayah-link"
                    >
                      Read on quran.com <ArrowRight size={14} />
                    </a>
                  </>
                ) : err ? (
                  <div className="text-cream/70 text-sm">Daily ayah unavailable right now.</div>
                ) : (
                  <div className="animate-shimmer h-48 rounded-2xl bg-cream/5" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
